import { CircularProgress } from "@mui/material"
import { BounceInDownButton } from "../animation/bounceIn"
import NodataFound from '../assets/images/empty.png'

export const PageLoader = () => {
    return (
        <div className='d-flex justify-content-center align-items-center' style={{ minHeight: "70vh" }}>
            <CircularProgress size={50} />
        </div>
    )
}

export const NoRecords = () => {
    return (
        <div className='d-flex justify-content-center align-items-center' style={{ minHeight: "70vh", opacity: "0.6" }}>
            <BounceInDownButton>
                <h4>There are no records!</h4>
            </BounceInDownButton>
        </div>
    )
}

export const NoDataFound = () => {
    return (
        <div className='d-flex justify-content-center align-items-center' style={{ minHeight: "70vh", opacity: "0.6" }}>
            <BounceInDownButton>
                <img
                    src={NodataFound}
                    alt="No records"
                    style={{ maxWidth: "70px" }}

                />
                <h4 style={{ marginTop: '8px' }}>No Data Found!</h4>
            </BounceInDownButton>
        </div>
    )
}